;$(function () {
  var initAvatarPlaceholders = function () {
    var avatars = document.querySelectorAll('[data-avatar-placeholder]')

    var PLACEHOLDER_BACKGROUND_COLORS = [
      '#B8E0F5',
      '#F1C5C5',
      '#C6D0F2',
      '#B2E1BA',
      '#EBACC7',
      '#DAB3DD',
      '#B6D3FD',
      '#EED990',
      '#ECC49E',
      '#94D2D6',
      '#E894B2',
      '#B3B0DC',
      '#F5EC98'
    ]
    var calcStringHash = function (string) {
      var hash = 0
      for (var i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash)
      }
      return Math.abs(hash % PLACEHOLDER_BACKGROUND_COLORS.length)
    }

    var getNameInitials = function (name) {
      name = name.replace(/[^\wА-Яа-я\s]/gi, '').replace('_', '').replace('и ', '').trim().toUpperCase().split(' ').slice(0, 2)
      for (var i = 0; i < name.length; i++) {
        name[i] = name[i].charAt(0)
      }
      return name.join('')
    }

    if (avatars) {
      for (var i = 0; i < avatars.length; i++) {
        var avatar = avatars[i]
        var name = avatar.getAttribute('data-name')
        var initialsBox = avatar.querySelector('[data-avatar-placeholder-initials]')
        var initialsFontSize = avatar.offsetWidth * 0.4
        avatar.style.backgroundColor = PLACEHOLDER_BACKGROUND_COLORS[calcStringHash(name)]
        initialsBox.textContent = getNameInitials(name)
        initialsBox.style.fontSize = initialsFontSize + 'px'
      }
    }
  }
  initAvatarPlaceholders()
  $(document).on('infiniteScroll::loaded Chat::afterThreadChange Chat::afterMessageSend Chat::afterDataInsert Chat::afterMessagesRendered Blogs::showPanel Blogs::createComment', initAvatarPlaceholders)
})
